// extracted by mini-css-extract-plugin
export default {"eventsContainer":"eventsContainer---CVu9R","fixedSessionBanner":"fixedSessionBanner---JotWR"};